import { HttpHeaders } from '@angular/common/http';
import { AngularFormioOptions } from '@formio/angular';
import { FormBuilder } from '@formio/js';
import { getApiUrl } from '../interceptors/api-interceptor.interceptor';

export type TFormioOptions = FormBuilder['options'] & AngularFormioOptions & { icons: string };

export const formIoEditForm: TFormioOptions = {
  editForm: {
    button: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    checkbox: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    columns: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    content: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    datetime: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    email: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    file: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    number: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    panel: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    phoneNumber: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    radio: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    select: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    selectboxes: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    table: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    textarea: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    textfield: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    time: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
    url: [
      {
        components: [
          {
            disabled: true,
            ignore: true,
            key: 'modalEdit',
          },
        ],
        key: 'display',
      },
    ],
  },
  icons: 'bi',
};

export const formIoConfiguration: TFormioOptions = {
  ...formIoEditForm,
  builder: {
    advanced: {
      componentOrder: ['email', 'url', 'phoneNumber', 'datetime', 'time'],
      components: {
        address: false,
        currency: false,
        datetime: {
          documentation: 'http://help.form.io/userguide/#datetime',
          group: 'advanced',
          icon: 'calendar',
          key: 'datetime',
          schema: {
            allowCalculateOverride: false,
            allowInput: true,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            customOptions: {},
            datePicker: {
              initDate: '',
              maxDate: null,
              maxMode: 'year',
              minDate: null,
              minMode: 'day',
              showWeeks: true,
              startingDay: 0,
              yearColumns: 5,
              yearRows: 4,
            },
            datepickerMode: 'day',
            dbIndex: false,
            defaultDate: '',
            defaultValue: '',
            description: '',
            disabled: false,
            displayInTimezone: 'viewer',
            enableDate: true,
            enableTime: true,
            encrypted: false,
            errorLabel: '',
            format: 'yyyy-MM-dd hh:mm a',
            hidden: false,
            hideLabel: false,
            input: true,
            key: 'dateTime',
            label: 'DateTime',
            labelPosition: 'top',
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: true,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            showCharCount: false,
            showWordCount: false,
            suffix: '',
            tabindex: '',
            tableView: false,
            timePicker: {
              arrowkeys: true,
              hourStep: 1,
              minuteStep: 1,
              mousewheel: true,
              readonlyInput: false,
              showMeridian: true,
            },
            timezone: '',
            tooltip: '',
            type: 'datetime',
            unique: false,
            useLocaleSettings: false,
            validate: {
              custom: '',
              customPrivate: false,
              multiple: false,
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            widget: {
              type: 'input',
            },
          },
          title: 'Date & Time',
          weight: 40,
        },
        day: false,
        email: {
          documentation: 'http://help.form.io/userguide/#email',
          group: 'advanced',
          icon: 'at',
          key: 'email',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            hidden: false,
            hideLabel: false,
            input: true,
            inputFormat: 'plain',
            inputMask: '',
            inputType: 'email',
            key: 'email',
            kickbox: {
              enabled: false,
            },
            label: 'Email',
            labelPosition: 'top',
            mask: false,
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: true,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            showCharCount: false,
            showWordCount: false,
            spellcheck: true,
            suffix: '',
            tabindex: '',
            tableView: true,
            tooltip: '',
            type: 'email',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              maxLength: '',
              minLength: '',
              multiple: false,
              pattern: '',
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            widget: {
              type: 'input',
            },
          },
          title: 'Email',
          weight: 10,
        },
        phoneNumber: {
          documentation: 'http://help.form.io/userguide/#phonenumber',
          group: 'advanced',
          icon: 'phone-square',
          key: 'phoneNumber',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            hidden: false,
            hideLabel: false,
            input: true,
            inputFormat: 'plain',
            inputMask: '(999) 999-9999',
            inputType: 'tel',
            key: 'phoneNumber',
            label: 'PhoneNumber',
            labelPosition: 'top',
            mask: false,
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: true,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            showCharCount: false,
            showWordCount: false,
            spellcheck: true,
            suffix: '',
            tabindex: '',
            tableView: true,
            tooltip: '',
            type: 'phoneNumber',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              maxLength: '',
              minLength: '',
              multiple: false,
              pattern: '',
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            widget: {
              type: 'input',
            },
          },
          title: 'Phone Number',
          weight: 30,
        },
        signature: false,
        survey: false,
        tags: false,
        time: {
          documentation: 'http://help.form.io/userguide/#time',
          group: 'advanced',
          icon: 'clock',
          key: 'time',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            conditional: {
              show: null,
              when: null,
              eq: '',
            },
            customClass: '',
            customDefaultValue: '',
            dataFormat: 'HH:mm:ss',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            format: 'HH:mm',
            hidden: false,
            hideLabel: false,
            input: true,
            inputFormat: 'plain',
            inputMask: '',
            inputType: 'time',
            key: 'time',
            label: 'Time',
            labelPosition: 'top',
            mask: false,
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: true,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            showCharCount: false,
            showWordCount: false,
            spellcheck: true,
            suffix: '',
            tabindex: '',
            tableView: true,
            tooltip: '',
            type: 'time',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              maxLength: '',
              minLength: '',
              multiple: false,
              pattern: '',
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            widget: {
              type: 'input',
            },
          },
          title: 'Time',
          weight: 55,
        },
        url: {
          documentation: 'http://help.form.io/userguide/#url',
          group: 'advanced',
          icon: 'link',
          key: 'url',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            conditional: {
              show: null,
              when: null,
              eq: '',
            },
            customClass: '',
            customDefaultValue: '',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            hidden: false,
            hideLabel: false,
            input: true,
            inputFormat: 'plain',
            inputMask: '',
            inputType: 'url',
            key: 'url',
            label: 'URL',
            labelPosition: 'top',
            mask: false,
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: true,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            showCharCount: false,
            showWordCount: false,
            spellcheck: true,
            suffix: '',
            tabindex: '',
            tableView: true,
            tooltip: '',
            type: 'url',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              maxLength: '',
              minLength: '',
              multiple: false,
              pattern: '',
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            widget: {
              type: 'input',
            },
          },
          title: 'URL',
          weight: 20,
        },
      },
      key: 'advanced',
      subgroups: [],
      title: 'Advanced',
      weight: 10,
    },
    basic: {
      componentOrder: ['textfield', 'textarea', 'number', 'checkbox', 'selectboxes', 'select', 'radio', 'button'],
      components: {
        button: {
          documentation: 'http://help.form.io/userguide/#button',
          group: 'basic',
          icon: 'stop',
          key: 'button',
          schema: {
            action: 'custom',
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            block: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            dataGridLabel: true,
            dbIndex: false,
            defaultValue: null,
            description: '',
            disableOnInvalid: false,
            disabled: false,
            encrypted: false,
            errorLabel: '',
            hidden: false,
            hideLabel: false,
            input: true,
            key: 'custom',
            label: 'Custom',
            labelPosition: 'top',
            leftIcon: '',
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: false,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            rightIcon: '',
            showCharCount: false,
            showWordCount: false,
            size: 'md',
            suffix: '',
            tabindex: '',
            tableView: false,
            theme: 'primary',
            tooltip: '',
            type: 'button',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              multiple: false,
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            widget: {
              type: 'input',
            },
          },
          title: 'Button',
          weight: 110,
        },
        checkbox: {
          documentation: 'http://help.form.io/userguide/#checkbox',
          group: 'basic',
          icon: 'check-square',
          key: 'checkbox',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            dataGridLabel: true,
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            hidden: false,
            hideLabel: false,
            input: true,
            inputType: 'checkbox',
            key: 'checkbox',
            label: 'Checkbox',
            labelPosition: 'right',
            modalEdit: false,
            multiple: false,
            name: '',
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: true,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            showCharCount: false,
            showWordCount: false,
            suffix: '',
            tabindex: '',
            tableView: false,
            tooltip: '',
            type: 'checkbox',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              multiple: false,
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            value: '',
            widget: null,
          },
          title: 'Checkbox',
          weight: 50,
        },
        number: {
          documentation: 'http://help.form.io/userguide/#number',
          group: 'basic',
          icon: 'hashtag',
          key: 'number',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            hidden: false,
            hideLabel: false,
            input: true,
            key: 'number',
            label: 'Number',
            labelPosition: 'top',
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: true,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            showCharCount: false,
            showWordCount: false,
            suffix: '',
            tabindex: '',
            tableView: false,
            tooltip: '',
            type: 'number',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              integer: '',
              max: '',
              min: '',
              multiple: false,
              required: false,
              step: 'any',
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            widget: {
              type: 'input',
            },
          },
          title: 'Number',
          weight: 30,
        },
        password: false,
        radio: {
          documentation: 'http://help.form.io/userguide/#radio',
          group: 'basic',
          icon: 'times-circle',
          key: 'radio',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            fieldSet: false,
            hidden: false,
            hideLabel: false,
            input: true,
            inputType: 'radio',
            key: 'radio',
            label: 'Radio',
            labelPosition: 'top',
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: true,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            showCharCount: false,
            showWordCount: false,
            suffix: '',
            tabindex: '',
            tableView: false,
            tooltip: '',
            type: 'radio',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              multiple: false,
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            values: [
              {
                label: '',
                value: '',
              },
            ],
            widget: null,
          },
          title: 'Radio',
          weight: 80,
        },
        select: {
          documentation: 'http://help.form.io/userguide/#select',
          group: 'basic',
          icon: 'th-list',
          key: 'select',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            authenticate: false,
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            clearOnRefresh: false,
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            customOptions: {},
            data: {
              custom: '',
              json: '',
              resource: '',
              url: '',
              values: [],
            },
            dataSrc: 'values',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            filter: '',
            fuseOptions: {
              include: 'score',
              threshold: 0.3,
            },
            hidden: false,
            hideLabel: false,
            input: true,
            key: 'select',
            label: 'Select',
            labelPosition: 'top',
            lazyLoad: true,
            limit: 100,
            minSearch: 0,
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: true,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            readOnlyValue: false,
            redrawOn: '',
            refreshOn: '',
            searchEnabled: true,
            searchField: '',
            searchThreshold: 0.3,
            selectFields: '',
            showCharCount: false,
            showWordCount: false,
            suffix: '',
            tabindex: '',
            tableView: true,
            template: '<span>{{ item.label }}</span>',
            tooltip: '',
            type: 'select',
            unique: false,
            uniqueOptions: false,
            validate: {
              custom: '',
              customPrivate: false,
              multiple: false,
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            valueProperty: '',
            widget: null,
          },
          title: 'Select',
          weight: 70,
        },
        selectboxes: {
          documentation: 'http://help.form.io/userguide/#selectboxes',
          group: 'basic',
          icon: 'plus-square',
          key: 'selectboxes',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            fieldSet: false,
            hidden: false,
            hideLabel: false,
            inline: false,
            input: true,
            inputType: 'radio',
            key: 'selectBoxes',
            label: 'SelectBoxes',
            labelPosition: 'top',
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: true,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            showCharCount: false,
            showWordCount: false,
            suffix: '',
            tabindex: '',
            tableView: false,
            tooltip: '',
            type: 'selectboxes',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              multiple: false,
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            values: [
              {
                label: '',
                value: '',
              },
            ],
            widget: null,
          },
          title: 'Select Boxes',
          weight: 60,
        },
        textarea: {
          documentation: 'http://help.form.io/userguide/#textarea',
          group: 'basic',
          icon: 'font',
          key: 'textarea',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            editor: '',
            encrypted: false,
            errorLabel: '',
            fixedSize: true,
            hidden: false,
            hideLabel: false,
            input: true,
            inputFormat: 'html',
            inputMask: '',
            inputType: 'text',
            key: 'textArea',
            label: 'TextArea',
            labelPosition: 'top',
            mask: false,
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: true,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            rows: 3,
            showCharCount: false,
            showWordCount: false,
            spellcheck: true,
            suffix: '',
            tabindex: '',
            tableView: true,
            tooltip: '',
            type: 'textarea',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              maxLength: '',
              maxWords: '',
              minLength: '',
              minWords: '',
              multiple: false,
              pattern: '',
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            widget: {
              type: 'input',
            },
            wysiwyg: false,
          },
          title: 'TextArea',
          weight: 20,
        },
        textfield: {
          documentation: 'http://help.form.io/userguide/#textfield',
          group: 'basic',
          icon: 'terminal',
          key: 'textfield',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            hidden: false,
            hideLabel: false,
            input: true,
            inputFormat: 'plain',
            inputMask: '',
            inputType: 'text',
            key: 'textField',
            label: 'TextField',
            labelPosition: 'top',
            mask: false,
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: true,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            showCharCount: false,
            showWordCount: false,
            spellcheck: true,
            suffix: '',
            tabindex: '',
            tableView: true,
            tooltip: '',
            type: 'textfield',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              maxLength: '',
              minLength: '',
              multiple: false,
              pattern: '',
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            widget: {
              type: 'input',
            },
          },
          title: 'Text Field',
          weight: 0,
        },
      },
      default: true,
      key: 'basic',
      subgroups: [],
      title: 'Basic',
      weight: 0,
    },
    data: false,
    layout: {
      componentOrder: ['content', 'columns', 'panel', 'table'],
      components: {
        columns: {
          documentation: 'http://help.form.io/userguide/#columns',
          group: 'layout',
          icon: 'columns',
          key: 'columns',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autoAdjust: false,
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: false,
            columns: [
              {
                components: [],
                offset: 0,
                pull: 0,
                push: 0,
                size: 'md',
                width: 6,
              },
              {
                components: [],
                offset: 0,
                pull: 0,
                push: 0,
                size: 'md',
                width: 6,
              },
            ],
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            hidden: false,
            hideLabel: false,
            hideOnChildrenHidden: false,
            input: false,
            key: 'columns',
            label: 'Columns',
            labelPosition: 'top',
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: false,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            showCharCount: false,
            showWordCount: false,
            suffix: '',
            tabindex: '',
            tableView: false,
            tooltip: '',
            tree: false,
            type: 'columns',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              multiple: false,
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            widget: null,
          },
          title: 'Columns',
          weight: 10,
        },
        content: {
          documentation: 'http://help.form.io/userguide/#content-component',
          group: 'layout',
          icon: 'code',
          key: 'content',
          preview: false,
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            hidden: false,
            hideLabel: false,
            html: '',
            input: false,
            key: 'content',
            label: 'Content',
            labelPosition: 'top',
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: true,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            showCharCount: false,
            showWordCount: false,
            suffix: '',
            tabindex: '',
            tableView: false,
            tooltip: '',
            type: 'content',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              multiple: false,
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            widget: null,
          },
          title: 'Content',
          weight: 5,
        },
        fieldset: false,
        htmlelement: false,
        panel: {
          documentation: 'http://help.form.io/userguide/#panels',
          group: 'layout',
          icon: 'list-alt',
          key: 'panel',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            breadcrumb: 'default',
            calculateServer: false,
            calculateValue: '',
            clearOnHide: false,
            components: [],
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            hidden: false,
            hideLabel: false,
            input: false,
            key: 'panel',
            label: 'Panel',
            labelPosition: 'top',
            modalEdit: false,
            multiple: false,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: false,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            showCharCount: false,
            showWordCount: false,
            suffix: '',
            tabindex: '',
            tableView: false,
            theme: 'default',
            title: 'Panel',
            tooltip: '',
            tree: false,
            type: 'panel',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              multiple: false,
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            widget: null,
          },
          title: 'Panel',
          weight: 30,
        },
        table: {
          documentation: 'http://help.form.io/userguide/#table',
          group: 'layout',
          icon: 'table',
          key: 'table',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            bordered: false,
            calculateServer: false,
            calculateValue: '',
            caption: '',
            clearOnHide: true,
            cloneRows: false,
            condensed: false,
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            header: [],
            hidden: false,
            hideLabel: false,
            hover: false,
            input: false,
            key: 'table',
            label: 'Table',
            labelPosition: 'top',
            modalEdit: false,
            multiple: false,
            numCols: 3,
            numRows: 3,
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: false,
            placeholder: '',
            prefix: '',
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            rows: [
              [
                {
                  components: [],
                },
                {
                  components: [],
                },
                {
                  components: [],
                },
              ],
              [
                {
                  components: [],
                },
                {
                  components: [],
                },
                {
                  components: [],
                },
              ],
              [
                {
                  components: [],
                },
                {
                  components: [],
                },
                {
                  components: [],
                },
              ],
            ],
            showCharCount: false,
            showWordCount: false,
            striped: false,
            suffix: '',
            tabindex: '',
            tableView: false,
            tooltip: '',
            tree: false,
            type: 'table',
            unique: false,
            validate: {
              custom: '',
              customPrivate: false,
              multiple: false,
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            widget: null,
          },
          title: 'Table',
          weight: 40,
        },
        tabs: false,
        well: false,
      },
      key: 'layout',
      subgroups: [],
      title: 'Layout',
      weight: 20,
    },
    premium: {
      componentOrder: ['file'],
      components: {
        file: {
          documentation: 'http://help.form.io/userguide/#file',
          group: 'premium',
          icon: 'file',
          key: 'file',
          schema: {
            allowCalculateOverride: false,
            allowMultipleMasks: false,
            attributes: {},
            autofocus: false,
            calculateServer: false,
            calculateValue: '',
            clearOnHide: true,
            conditional: {
              eq: '',
              show: null,
              when: null,
            },
            customClass: '',
            customDefaultValue: '',
            dbIndex: false,
            defaultValue: null,
            description: '',
            disabled: false,
            encrypted: false,
            errorLabel: '',
            fileMaxSize: '10MB',
            fileMinSize: '0KB',
            filePattern: '*',
            hidden: false,
            hideLabel: false,
            image: false,
            imageSize: '200',
            input: true,
            key: 'file',
            label: 'Upload',
            labelPosition: 'top',
            modalEdit: false,
            multiple: false,
            options: JSON.stringify({
              headers: new HttpHeaders({ 'Content-Type': 'application/pdf' }),
              withCredentials: true,
            }),
            overlay: {
              height: '',
              left: '',
              style: '',
              top: '',
              width: '',
            },
            persistent: true,
            placeholder: '',
            prefix: '',
            privateDownload: false,
            properties: {},
            protected: false,
            redrawOn: '',
            refreshOn: '',
            showCharCount: false,
            showWordCount: false,
            storage: 'url',
            suffix: '',
            tabindex: '',
            tableView: false,
            tooltip: '',
            type: 'file',
            unique: false,
            uploadOnly: false,
            url: `${getApiUrl()}/files/upload/`,
            validate: {
              custom: '',
              customPrivate: false,
              multiple: false,
              required: false,
              strictDateValidation: false,
              unique: false,
            },
            validateOn: 'change',
            widget: null,
          },
          title: 'File',
          weight: 100,
        },
        form: false,
        recaptcha: false,
        resource: false,
        unknown: false,
      },
      key: 'premium',
      subgroups: [],
      title: 'Premium',
      weight: 40,
    },
  },
  editForm: {
    url: [
      {
        components: [
          {
            hidden: true,
            key: 'multiple',
          },
        ],
        key: 'data',
      },
    ],
  },
  noDefaultSubmitButton: true,
};

export const textFieldBuilderConfig = [
  {
    ignore: true,
    key: 'api',
  },
  {
    ignore: true,
    key: 'data',
  },
  {
    ignore: true,
    key: 'conditional',
  },
  {
    ignore: true,
    key: 'logic',
  },
  {
    ignore: true,
    key: 'layout',
  },
  {
    ignore: true,
    key: 'layout',
  },
  {
    ignore: true,
    key: 'logic',
  },
  {
    ignore: true,
    key: 'conditional',
  },
  {
    components: [
      {
        ignore: true,
        key: 'widget.type',
      },
      {
        ignore: true,
        key: 'inputMask',
      },
      {
        ignore: true,
        key: 'displayMask',
      },
      {
        ignore: true,
        key: 'applyMaskOn',
      },
      {
        ignore: true,
        key: 'customClass',
      },
      {
        ignore: true,
        key: 'tabindex',
      },
      {
        ignore: true,
        key: 'allowMultipleMasks',
      },
      {
        ignore: true,
        key: 'autocomplete',
      },
      {
        ignore: true,
        key: 'hidden',
      },
      {
        ignore: true,
        key: 'mask',
      },
      {
        ignore: true,
        key: 'tableView',
      },
      {
        ignore: true,
        key: 'modalEdit',
      },
      {
        ignore: true,
        key: 'defaultValue',
      },
      {
        ignore: true,
        key: 'persistent',
      },
    ],
    key: 'display',
    label: 'Display',
  },
  {
    components: [
      {
        ignore: true,
        key: 'unique',
      },
      {
        ignore: true,
        key: 'validateWhenHidden',
      },
      {
        ignore: true,
        key: 'validate.pattern',
      },
      {
        ignore: true,
        key: 'errorLabel',
      },
      {
        ignore: true,
        key: 'customMessage',
      },
      {
        ignore: true,
        key: 'validate.customMessage',
      },
      {
        ignore: true,
        key: 'custom-validation-js',
      },
      {
        ignore: true,
        key: 'json-validation-json',
      },
      {
        ignore: true,
        key: 'errors',
      },
    ],
    key: 'validation',
    label: 'Validation',
  },
];

export const selectBoxesBuilderConfig = [
  {
    ignore: true,
    key: 'api',
  },
  {
    ignore: true,
    key: 'conditional',
  },
  {
    ignore: true,
    key: 'logic',
  },
  {
    ignore: true,
    key: 'layout',
  },
  {
    components: [
      {
        ignore: true,
        key: 'widget.type',
      },
      {
        ignore: true,
        key: 'inputMask',
      },
      {
        ignore: true,
        key: 'displayMask',
      },
      {
        ignore: true,
        key: 'applyMaskOn',
      },
      {
        ignore: true,
        key: 'customClass',
      },
      {
        ignore: true,
        key: 'tabindex',
      },
      {
        ignore: true,
        key: 'allowMultipleMasks',
      },
      {
        ignore: true,
        key: 'autocomplete',
      },
      {
        ignore: true,
        key: 'hidden',
      },
      {
        ignore: true,
        key: 'mask',
      },
      {
        ignore: true,
        key: 'tableView',
      },
      {
        ignore: true,
        key: 'modalEdit',
      },
      {
        ignore: true,
        key: 'defaultValue',
      },
    ],
    key: 'display',
    label: 'Display',
  },
  {
    components: [
      {
        ignore: true,
        key: 'unique',
      },
      {
        ignore: true,
        key: 'validateWhenHidden',
      },
      {
        ignore: true,
        key: 'validate.pattern',
      },
      {
        ignore: true,
        key: 'errorLabel',
      },
      {
        ignore: true,
        key: 'customMessage',
      },
      {
        ignore: true,
        key: 'validate.customMessage',
      },
      {
        ignore: true,
        key: 'custom-validation-js',
      },
      {
        ignore: true,
        key: 'json-validation-json',
      },
      {
        ignore: true,
        key: 'errors',
      },
    ],
    key: 'validation',
    label: 'Validation',
  },
  {
    components: [
      {
        ignore: true,
        key: 'dataSrc',
      },
      {
        ignore: true,
        key: 'persistent',
      },
      {
        ignore: true,
        key: 'protected',
      },
      {
        ignore: true,
        key: 'dbIndex',
      },
      {
        ignore: true,
        key: 'encrypted',
      },
      {
        ignore: true,
        key: 'clearOnHide',
      },
      {
        ignore: true,
        key: 'customDefaultValuePanel',
      },
      {
        ignore: true,
        key: 'calculateValuePanel',
      },
      {
        ignore: true,
        key: 'calculateServer',
      },
      {
        ignore: true,
        key: 'allowCalculateOverride',
      },
    ],
    key: 'data',
    label: 'Data',
  },
];

export const buttonBuilderConfig = [
  {
    ignore: true,
    key: 'api',
  },
  {
    ignore: true,
    key: 'data',
  },
  {
    ignore: true,
    key: 'conditional',
  },
  {
    ignore: true,
    key: 'logic',
  },
  {
    ignore: true,
    key: 'layout',
  },
  {
    ignore: true,
    key: 'layout',
  },
  {
    ignore: true,
    key: 'logic',
  },
  {
    ignore: true,
    key: 'conditional',
  },
  {
    ignore: true,
    key: 'validation',
  },
  {
    components: [
      {
        ignore: true,
        key: 'action',
      },
      {
        ignore: true,
        key: 'saveOnEnter',
      },
      {
        ignore: true,
        key: 'widget.type',
      },
      {
        ignore: true,
        key: 'inputMask',
      },
      {
        ignore: true,
        key: 'displayMask',
      },
      {
        ignore: true,
        key: 'applyMaskOn',
      },
      {
        ignore: true,
        key: 'customClass',
      },
      {
        ignore: true,
        key: 'tabindex',
      },
      {
        ignore: true,
        key: 'allowMultipleMasks',
      },
      {
        ignore: true,
        key: 'autocomplete',
      },
      {
        ignore: true,
        key: 'hidden',
      },
      {
        ignore: true,
        key: 'mask',
      },
      {
        ignore: true,
        key: 'tableView',
      },
      {
        ignore: true,
        key: 'modalEdit',
      },
      {
        ignore: true,
        key: 'defaultValue',
      },
      {
        ignore: true,
        key: 'persistent',
      },
    ],
    key: 'display',
    label: 'Display',
  },
];
